import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import EnvContext, {Env} from 'contexts/EnvContext';

export interface WithEnvProps {
    env: Env;
}

export default function withEnv<T extends WithEnvProps>(WrappedComponent: React.ComponentType<T>) {
    class WithEnv extends React.Component<Omit<T, keyof WithEnvProps>> {
        static displayName = `withEnv(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = EnvContext;

        render() {
            return <WrappedComponent {...(this.props as T)} env={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithEnv, WrappedComponent);
    return WithEnv;
}
